import { render, staticRenderFns } from "./DeviceSettingInfoWaiting.vue?vue&type=template&id=70d8e2a6&scoped=true&"
import script from "./DeviceSettingInfoWaiting.vue?vue&type=script&lang=js&"
export * from "./DeviceSettingInfoWaiting.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSettingInfoWaiting.vue?vue&type=style&index=0&id=70d8e2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8e2a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d8e2a6')) {
      api.createRecord('70d8e2a6', component.options)
    } else {
      api.reload('70d8e2a6', component.options)
    }
    module.hot.accept("./DeviceSettingInfoWaiting.vue?vue&type=template&id=70d8e2a6&scoped=true&", function () {
      api.rerender('70d8e2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/DeviceSetting/Info/DeviceSettingInfoWaiting.vue"
export default component.exports